import React from 'react'
import { useNavigate } from 'react-router-dom'
import './SpesialBlock.css'
import useImagePreload from '../../hooks/useImagePreload'
import specialImage from '../../asset/main-slider/special.avif'

const SpesialBlock = () => {
  const navigate = useNavigate()
  const isImageLoaded = useImagePreload(specialImage)

  const handleMoreClick = () => {
    navigate('/services/cvetnoj-poliuritan/oklejka-vinilovoj-plenkoj')
  }

  return (
    <section
      className="special-block"
      style={{ '--special-bg-image': `url(${specialImage})` }}
      aria-label="Специальное предложение"
    >
      <div
        className={`special-block__skeleton img-skeleton ${isImageLoaded ? 'is-hidden' : ''}`}
        aria-hidden="true"
      />
      <img
        className={`special-block__mobile-image img-fade-in ${isImageLoaded ? 'is-loaded' : ''}`}
        src={specialImage}
        alt=""
        aria-hidden="true"
      />
      <div className="special-block__overlay" />
      <div className="special-block__content">
        <h2 className="special-block__title">Специальное предложение</h2>
        <p className="special-block__description">
          Полная оклейка
          <br />
          кузова за 3 дня
        </p>
        <button type="button" className="special-block__button" onClick={handleMoreClick}>
          Узнать подробнее
        </button>
      </div>
    </section>
  )
}

export default SpesialBlock